<template>
  <div>
    <div
      class="text-center" 
      v-if="loading"
      style="padding: 20px;"
    >
      <v-progress-circular
        :size="50"
        :width="7"
        :color="BGColor"
        indeterminate
        style="opacity: 0.5;"
      />
    </div>
    <iframe
      id="iframeCustom"
      v-if="url"
      :src="url"
      :height="isBigScreen ? 2000 : data && data.IframeHeight"
      frameborder="0"
      width="100%"
      seamless="seamless"
      @load="handleLoadComplete"
      v-show="!loading"
allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    />
      <div 
        v-if="isDesktop && url === 'https://vicom360.es/abama/360'"
        class="tmpAba" 
      />
  </div>
</template>

 <script>
  import constants from '@/constants'
  import utils from '@/services/utils'
  import _ from 'lodash'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
      loading: false,
      url: null,
    }),
    computed: {
      BGColor () {
        return this.$store.state.app.BGColor
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      },
      isBigScreen () {
        return this.$route.query.b ? true : false
      },
    },
    watch: {
      'data.IframeURL' (v) {
        this.prepareURL()
      }
    },
    created () {
      this.handleLoadComplete = _.debounce(() => {
        this.loading = false
      }, 500)
    },
    mounted () {
      this.prepareURL()
    },
    methods: {
      prepareURL() {
        if (this.data && this.data.IframeNotLoading) this.loading = false
        if(this.data && this.data.IframeURL) {
          if(this.data.IframeURL.indexOf('$LOPESAN$') > 0) {
            const aux = this.$store.state.app.authData
            if (aux && aux.id)this.url = this.data.IframeURL.replace('$LOPESAN$', aux.id)
          } else {
            this.url = this.data.IframeURL
          }
        }
      }
    //   handleLoadComplete () {
    //     // this.loading = false
    //     const that = this
    //     _.debounce(() => {
    //       that.loading = false
    //     }, 500)
    //   }
    }
  }
</script>
<style>
  iframe {
    overflow-x:hidden;
    overflow-y:hidden;
    overflow:hidden;
  }
  .tmpAba {
    position: fixed;
    top: 70px;
    right: 0px;
    width: 100px;
    height: 100px;
  }
</style>
